<app-adjustable-loader [isLoading]="isLoading" [topOffset]="'20vh'"></app-adjustable-loader>
@if(!isMobileView){
<div class="manage-user-section">
  <div class="manage-user-header">
    <h1 class="manage-user-text">Manage users</h1>
    <div class="manage-user-search-box-section">
      <div style="display: flex; gap: 12px;">
        <button class="dp-primary-btn" style="padding: 10px 12px;" (click)="openFilterDialog()">
          <span class="filter-button-text">Filter
          </span>
        </button>
        <input type="text" placeholder="Search anything" class="manage-user-search-box-input dp-input-control"
          [formControl]="searchTerm" />
      </div>
    </div>
  </div>
  <!-- (ngModelChange)="onInputChange($event)" -->

  <!-- data table  -->
  @if(isLoader){
  @if(isLoader){
  <table class="dp-table">
    <thead class="dp-table-header">
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Contact</th>
        <th>District</th>
        <!-- <th>Role</th> -->
        <th>Status</th>
        <th>Privilege</th>
        <th> </th>
      </tr>
    </thead>
    <tbody class="dp-table-body">
      <tr *ngFor="let i of [].constructor(numberOfLoaders)">
        <td *ngFor="let j of [].constructor(9)">
          <dp-loader></dp-loader>
        </td>
      </tr>
    </tbody>
  </table>
  }
  } @else {
  <div class="dp-table-scroll" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    [scrollWindow]="false" (scrolled)="onScrollTable()">
    <dp-table [dataTable]="datatable" [displayedColumns]="displayColumnData" [componentMap]="cellComponentMap"
      (cellClick)="openDialog($event)" [isLoader]="isLoader"></dp-table>
  </div>
  }
</div>
} @else {
<div class="manage-user-section">

  <div class="manage-user-search-box-section">
    <input type="text" placeholder="Search by username/email address"
      class="manage-user-search-box-input dp-input-control" [formControl]="searchTerm" />
  </div>

  <div class="manage-user-button-group">
    <!-- <button class="filter-button" (click)="toggleFilterOptions()">
      <h1 class="filter-button-text">Filter</h1>
      <img src="assets/filter.svg" />
    </button>
    <div class="separatorDiv"></div> -->

    <!-- @if(toggleFilter){ -->
    <div class="d-flex filter-options flex-column">
      <div class="custom-dropdown">
        <!-- <select id="stateSelect" class="dropdown-select" [(ngModel)]="selectedState" (change)="onStateChange($event)">
              <option value="" disabled selected>Select State</option>
              <option *ngFor="let state of states" [value]="state.value" class="custom-option">{{ state.text }}</option>
            </select> -->

        <mat-form-field class="select-mat-form-field custom-select-form">
          <mat-select class="custom-mat-select custom-select" id="state" [(ngModel)]="selectedState"
            placeholder="Select State">
            <mat-option *ngFor="let state of states" [value]="state" (click)="getDistrictList(state)">
              {{ state }}
            </mat-option>
          </mat-select>
          <button mat-icon-button *ngIf="selectedState != ''" matSuffix class="clear-button">
            <mat-icon class="clear-icon">clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="custom-dropdown">

        <mat-form-field class="select-mat-form-field custom-select-form">
          <mat-select class="custom-mat-select" id="district" [(ngModel)]="selectedDistrict"
            placeholder="Select District">
            <mat-option *ngFor="let district of districts[selectedState]" [value]="district">
              {{ district }}
            </mat-option>
          </mat-select>
          <button mat-icon-button *ngIf="selectedDistrict != ''" matSuffix class="clear-button">
            <mat-icon class="clear-icon">clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="custom-dropdown">
        <mat-form-field class="select-mat-form-field custom-select-form">
          <mat-select class="custom-mat-select" id="level" [(ngModel)]="selectedLevel" placeholder="Select Level">
            <mat-option *ngFor="let level of levels" [value]="level">
              {{ level }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!-- } -->
  </div>

  <div class="dataList">
    @if(isLoader){

    }
    @else {
    <div class="scroll-container" (scroll)="onScroll($event)">
      @if(datatable.length !== 0){ @for( lists of datatable; track lists){
      <ul class="eachdataList">
        <li class="data">
          Name<span>{{ lists.name ? lists.name : "-" }}</span>
        </li>
        <li class="data">
          Email address
          <span>{{ lists.email ? lists.email : "-" }}</span>
        </li>
        <li class="data">
          Contact
          <span>{{ lists.contact ? lists.contact : "-" }}</span>
        </li>
        <li class="data">
          District
          <span>{{ lists.district ? lists.district : "-" }}</span>
        </li>
        <li class="data">
          Role
          <span>{{ lists.role ? lists.role : "-" }}</span>
        </li>
        <li class="data">
          Status
          <span>{{ lists.status ? lists.status : "-" }}</span>
        </li>
        <li class="data">
          Privilege
          <span>{{ lists.privilege ? lists.privilege : "-" }}</span>
        </li>
        <div class="d-flex align-items-center btn-gap justify-content-between">
          <button class="manage-user-btn dp-secondary-btn view-btn" (click)="openDialogMobile(lists)">
            Manage
          </button>
        </div>
        <!-- <wislist-action (cellClick)="onCellClick($event)"></wislist-action> -->
      </ul>
      }}
      <!-- @else{
        <div class="d-flex justify-content-center align-items-center mt-10">
          No records found
        </div>
        } -->
    </div>
    }

  </div>
</div>
}